const publicPaths = ['/login', '/register', '/forgot-password', '/privacy-policy', '/contact-us/account-delete'];

// The shape the /set-password/:token route matches: a cut-off link has no page to show.
const setPasswordPath = /^\/set-password\/[^/]+\/?$/;

export function isPublicPath(pathname) {
  return publicPaths.includes(pathname) || setPasswordPath.test(pathname);
}

export function shouldRedirectToLogin(user, pathname) {
  return user === null && !isPublicPath(pathname);
}

export function shouldShowNavBars(user, pathname) {
  return user !== null && !isPublicPath(pathname);
}
